module.exports = __webpack_public_path__ + "static/media/cuffBracelet.a195aeed.png";